export default __webpack_public_path__ + "static/media/instagram.fca4265d.svg";